import CaseFields from "./component";
export default CaseFields;